namespace $.$$ {

	/** Позиция прочтения участника: Moment последнего прочитанного сообщения. */
	export class $bog_gram_read extends $giper_baza_dict.with({
		Moment: $giper_baza_atom_real,
	}) {}

}
